export enum ParkAreaAssesmentStatus {
	PASSED = 'PASSED',
	PARTIALLY_PASSED = 'PARTIALLY_PASSED',
	NOT_PASSED = 'NOT_PASSED',
	NOT_STARTED = 'NOT_STARTED',
}
